
import { data } from "@/model/Data";
import Vue from "vue";
import NumberInputSpinner from "vue-number-input-spinner";

import {VueDatePicker} from "@mathieustan/vue-datepicker";
import "@mathieustan/vue-datepicker/dist/vue-datepicker.min.css";

export default Vue.extend({
    
    data: () => ({
        api: data,
        gender: {val: -1},
        edu: 0,
        details: 0,
        menu: false,
        date: null as unknown as string,
        activePicker: "YEAR",
    }),

    components: {NumberInputSpinner, VueDatePicker},

    watch: {
        menu(val) {
            val && setTimeout(() => (this.$refs.menu.$refs.agenda.mode = 'year'));
        }
    },

    methods: {

        info() {
            // Input validation (Add popup for this)
            if (this.gender.val == 0) return;
            if (this.date == null) return;

            // Retarded code to calculate age from bday
            var now = new Date();
            var bday = new Date(Date.parse(this.date));
            this.api.age = now.getFullYear() - bday.getFullYear();
            now.setFullYear(now.getFullYear() - this.api.age);
            if (now.valueOf() < bday.valueOf()) this.api.age -= 1;

            this.$emit("complete");
        }
    },  
});
